import $ from 'jquery';

export const videoArchive = () => {
  const $videoGrid = $('.video-archive-index');
  const $techniqueSelect = $videoGrid.find('.select-technique');
  const $materialSelect = $videoGrid.find('.select-material');
  const baseUrl = document.location.href.split('?')[0];

  $techniqueSelect.on('change', (e) => {
    getRequest($techniqueSelect.val(), $materialSelect.val());
  });

  $materialSelect.on('change', (e) => {
    getRequest($techniqueSelect.val(), $materialSelect.val());
  });

  const getRequest = (technique, material) => {
    if (technique && material) {
      window.location = `${baseUrl}?techniques=${technique}&materials=${material}`;
    }
    if (technique && !material) {
      window.location = `${baseUrl}?techniques=${technique}`;
    }
    if (material && !technique) {
      window.location = `${baseUrl}?materials=${material}`;
    }
    if (!material && !technique) {
      window.location = baseUrl;
    }
  };
};
